import React, { lazy, Suspense, useState, useEffect } from "react"
import useDeepCompareEffect from 'use-deep-compare-effect'

import CardSkeletons from "components/post/singCard/cardSkeletons"
const Slider = lazy(() => import("./slider"))
// const Slider = lazy(() => import('components/slider'))
import "./quoteBlock.scss"

const QuoteBlock = ({ block }) => {
  // const [posts, setPosts] = useState(block.quoteCards.quotes.map((post) => cardFromPost(post)))
  // useDeepCompareEffect(() => {
  //   if (block && block.quoteCards && block.quoteCards.quotes.length > 0) {
  //     const posts = block.quoteCards.quotes.map((post) => cardFromPost(post))
  //     setPosts(posts)
  //   }

  // }, [block, posts])
  return (
    <div className={`wp-block ${block.name.replace("/", "-")}`}>
      <div className="container heading">
        {block.quoteCards.heading && (
          <h3>{block.quoteCards.heading}</h3>
        )}
      </div>
      <div className='slider'>
        <Suspense fallback={<CardSkeletons num={1} />}>
          <Slider data={block.quoteCards.quotes} />
          {/* <Slider data={posts} /> */}
        </Suspense>
      </div>
    </div>
  )
}
export const cardFromPost = (post) => {
  return <div >
    <blockquote>{post.quote}</blockquote>
    <span className='name'>{post.attribution}</span>
  </div>
}
export default QuoteBlock
